module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "PL_Title-Page-Dividing-Line",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('a', {
    attrs: {
      "id": "here"
    }
  }), _c('b', [_vm._v("A convenient arrangement: Three festive Regency romances!")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("In "), _c('i', [_vm._v("The Captain’s Christmas Journey")]), _vm._v(" by Carla Kelly, Captain Everard is escorting Verity to her governess job—and for propriety’s sake that means a convenient engagement! ")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("In Louise Allen’s "), _c('i', [_vm._v("The Viscount’s Yuletide Betrothal")]), _vm._v(", Eleanor advertises for a “suitable” gentleman to pose as her betrothed over Christmas. ")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("And in Laurie Benson’s novella, Juliet Sommersby’s "), _c('i', [_vm._v("One Night Under the Mistletoe")]), _vm._v(" leads to a marriage of convenience with handsome former love Lord Montague..."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "pl-epigraph"
  }, [_vm._v("“A lovely, whimsical tale with unforgettable characters and richly detailed prose and lots of Christmas magic thrown in. The story of long-lost lovers finding each other against all odds proves a powerful one.”")]), _vm._v(" "), _c('p', {
    staticClass: "pl-citation"
  }, [_vm._v("—"), _c('i', [_vm._v("RT Book Reviews")]), _vm._v(" on “Captain Grey’s Christmas Proposal” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Regency Christmas Wishes")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-epigraph"
  }, [_vm._v("“An enchanting, enjoyable and tender hearted historical romance about second chances, convenient arrangements and everlasting love.” ")]), _vm._v(" "), _c('p', {
    staticClass: "pl-citation"
  }, [_vm._v("—"), _c('i', [_vm._v("Goodreads")]), _vm._v(" on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Earl’s Practical Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-epigraph"
  }, [_vm._v("“A very beautiful fantastic book by an author who never lets us down, truly utterly adored from start to finish.”")]), _vm._v(" "), _c('p', {
    staticClass: "pl-citation"
  }, [_vm._v("—"), _c('i', [_vm._v("Goodreads")]), _vm._v(" on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("An Unexpected Countess")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58766fab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Back_Cover_Text.vue
// module id = 57
// module chunks = 0